import React, { useState } from 'react';
import { Download, CheckCircle, AlertCircle } from 'lucide-react';

const ExportControls = ({ onExport, disabled }) => {
  const [exporting, setExporting] = useState(false);
  const [exportStatus, setExportStatus] = useState(null);

  const handleExport = async (format) => {
    try {
      setExporting(true);
      setExportStatus(null);
      
      await onExport(format);
      
      setExportStatus({ type: 'success', message: 'Export completed successfully!' });
      setTimeout(() => setExportStatus(null), 3000);
    } catch (error) {
      setExportStatus({ 
        type: 'error', 
        message: error?.message || 'Failed to export activity logs' 
      });
      setTimeout(() => setExportStatus(null), 5000);
    } finally {
      setExporting(false);
    }
  };

  return (
    <div className="relative">
      <button
        onClick={() => handleExport('csv')}
        disabled={disabled || exporting}
        className="flex items-center gap-2 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {exporting ? (
          <>
            <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
            Exporting...
          </>
        ) : (
          <>
            <Download className="w-4 h-4" />
            Export CSV
          </>
        )}
      </button>
      {/* Export Status Toast */}
      {exportStatus && (
        <div className={`absolute top-full right-0 mt-2 w-64 p-3 rounded-lg shadow-lg border ${
          exportStatus?.type === 'success' ?'bg-green-50 border-green-200' :'bg-red-50 border-red-200'
        }`}>
          <div className="flex items-start gap-2">
            {exportStatus?.type === 'success' ? (
              <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
            ) : (
              <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
            )}
            <div>
              <p className={`text-sm font-medium ${
                exportStatus?.type === 'success' ? 'text-green-900' : 'text-red-900'
              }`}>
                {exportStatus?.type === 'success' ? 'Success!' : 'Export Failed'}
              </p>
              <p className={`text-xs mt-1 ${
                exportStatus?.type === 'success' ? 'text-green-700' : 'text-red-700'
              }`}>
                {exportStatus?.message}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExportControls;